import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=4d0d90ec&scoped=true&"
import script from "./FormBody.vue?vue&type=script&lang=js&"
export * from "./FormBody.vue?vue&type=script&lang=js&"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=4d0d90ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d90ec",
  null
  
)

export default component.exports